export default __webpack_public_path__ + "static/media/quick_reference_all.ff6b39c9.svg";